import { webApiEndpoints } from "../config";
import { mapper } from "../helpers/mapper.helper";
import { AppRequestType, AppCategories, BlogItem } from "../types";

const category: AppCategories = 'blog'

export const blogAdapter = {

    getEntries: (): AppRequestType<BlogItem[]>[typeof category]['getBlogEntries'] => ({
        endpoint: webApiEndpoints[category].getBlogEntries,
        keepCacheBeforeNewRequest: true,
        input: null,
        output: (datos) => datos.map(mapper.apiBlogEntry).sort((a, b) => b.id - a.id)
    }),

    addEntry: (data: BlogItem): AppRequestType<BlogItem>[typeof category]['addBlogEntry'] => ({
        endpoint: webApiEndpoints[category].addBlogEntry,
        input: {
            autor: data.author,
            comentariosHabilitados: data.withComments,
            indiceHabilitado: data.withIndex,
            id: 0,
            keywords: data.keywords.join(','),
            sinopsis: data.description,
            titulo: data.title,
            url: data.link
        },
        output: (datos) => mapper.apiBlogEntry(datos)
    }),


    editEntry: (data: BlogItem): AppRequestType<BlogItem>[typeof category]['editBlogEntry'] => ({
        endpoint: webApiEndpoints[category].editBlogEntry,
        input: {
            autor: data.author,
            comentariosHabilitados: data.withComments,
            indiceHabilitado: data.withIndex,
            id: data.id,
            keywords: data.keywords.join(','),
            sinopsis: data.description,
            titulo: data.title,
            url: data.link
        },
        output: (datos) => mapper.apiBlogEntry(datos)
    }),

    deleteEntry: (data: BlogItem): AppRequestType<BlogItem>[typeof category]['deleteBlogEntry'] => ({
        endpoint: webApiEndpoints[category].deleteBlogEntry,
        input: {
            autor: data.author,
            comentariosHabilitados: data.withComments,
            indiceHabilitado: data.withIndex,
            id: data.id,
            keywords: '',
            sinopsis: '',
            titulo: '',
            url: ''
        },
        output: (datos) => mapper.apiBlogEntry(datos)
    }),

}